import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../utils/firebaseConfig';
import GeneralNavbar from './GeneralNavbar';
import './EditEmployee.css'; // ✅ Usa el mismo CSS que compartiste

function EditClient() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [clientData, setClientData] = useState({
    name: '',
    apellido: '',
    email: '',
    telefono: '',
  });

  useEffect(() => {
    const fetchClient = async () => {
      const clientRef = doc(db, 'users', id);
      const clientSnap = await getDoc(clientRef);
      if (clientSnap.exists()) {
        setClientData(clientSnap.data());
      } else {
        alert('Cliente no encontrado');
        navigate('/admin/clients');
      }
    };
    fetchClient();
  }, [id, navigate]);

  const handleChange = (e) => {
    setClientData({ ...clientData, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    try {
      const clientRef = doc(db, 'users', id);
      await updateDoc(clientRef, clientData);
      alert('Cliente actualizado correctamente');
      navigate('/admin/clients');
    } catch (error) {
      console.error('Error actualizando cliente:', error);
      alert('Error actualizando el cliente');
    }
  };

  return (
    <>
      <GeneralNavbar title="Editar Cliente" onBackClick={() => navigate('/admin/clients')} />
      <div className="edit-employee-container">
        <form className="edit-employee-form" onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
          <input
            type="text"
            name="name"
            placeholder="Nombre"
            value={clientData.name}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="apellido"
            placeholder="Apellido"
            value={clientData.apellido}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Correo Electrónico"
            value={clientData.email}
            onChange={handleChange}
            required
            disabled
          />
          <input
            type="text"
            name="telefono"
            placeholder="Teléfono"
            value={clientData.telefono || ''}
            onChange={handleChange}
            required
          />

          <button type="submit" className="submit-button">Guardar Cambios</button>
        </form>
      </div>
    </>
  );
}

export default EditClient;
